'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDevice = exports.getDeviceTypes = exports.getDeviceTypesForSassLoader = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deviceTypes = ['IS_MOBILE', 'IS_NATIVE', 'IS_DESKTOP', 'IS_TABLET', 'IS_LITE'];

/**
 * Gets device type environment variable
 * for SASS loader/WHCSS framework
 * @param {Object} env Env object
 * @returns {String} Device types string
 */

var getDeviceTypesForSassLoader = exports.getDeviceTypesForSassLoader = function getDeviceTypesForSassLoader() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var res = deviceTypes.reduce(function (result, type) {
        return env[type] ? result + '$' + type + ':' + env[type] + ';' : result;
    }, '');

    if (res === '') {
        res = '$IS_MOBILE:true;';
    }

    return res;
};

/**
 * Gets device types from process.env
 * @param {Object} env Env object
 * @returns {Object} Device types object
 */

var getDeviceTypes = exports.getDeviceTypes = function getDeviceTypes() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var res = deviceTypes.reduce(function (result, type) {
        var acc = result;

        if (env[type]) {
            acc[type] = env[type];
        }

        return acc;
    }, {});

    if ((0, _keys2.default)(res).length === 0) {
        res = {
            IS_MOBILE: true
        };
    }

    return res;
};

/**
 * Gets device name from process.env
 * @param {Object} env Env object
 * @returns {String} Device name
 */

var getDevice = exports.getDevice = function getDevice() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var currentDeviceTypes = getDeviceTypes(env);
    var deviceType = (0, _keys2.default)(currentDeviceTypes)[0];

    return deviceType.toLowerCase().replace('is_', '');
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/device-constants/dist/main/index.js
// module id = 465
// module chunks = 0